module.exports = __webpack_public_path__ + "static/img/lifestyle_28.a0abcfc9.jpeg";